// Task 11 (fix round 1) — extraído de `exportExcelMultiSheet.ts`/`exportExcel.ts`: ambos módulos
// reescribieron su generación de Excel sobre `exceljs` en la misma tarea y terminaron con el mismo
// bloque de ~9 líneas (buffer → Blob → URL de objeto → <a download> → click → cleanup) copiado dos
// veces. Este archivo centraliza ese único mecanismo de descarga para que no vuelva a duplicarse.
import type ExcelJS from 'exceljs';

const TIPO_MIME_EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/**
 * Convierte un `ExcelJS.Workbook` ya armado a buffer y dispara su descarga en el navegador como
 * archivo `.xlsx`. `fileName` debe llegar con la extensión ya resuelta por el caller — cada módulo
 * que arma el workbook decide su propio criterio de normalización de nombre (con o sin extensión
 * previa).
 */
export async function descargarWorkbookComoExcel(
  workbook: ExcelJS.Workbook, fileName: string,
): Promise<void> {
  const buffer = await workbook.xlsx.writeBuffer();
  descargarBlobComoExcel(new Blob([buffer], { type: TIPO_MIME_EXCEL }), fileName);
}

/**
 * 2026-10-13 — Descarga un `.xlsx` que ya llegó armado (el libro de Brillamos Juntos que genera el
 * servidor). Mismo mecanismo que `descargarWorkbookComoExcel`.
 */
export function descargarBlobComoExcel(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = fileName;
  document.body.appendChild(enlace);
  enlace.click();
  document.body.removeChild(enlace);
  URL.revokeObjectURL(url);
}
